export default "__VITE_ASSET__DlaUSYWu__"